// extracted by mini-css-extract-plugin
export default {"root":"_1gwX5","stat":"GxmUi","label":"_1sRbR"};